/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Wait/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Wait({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/Wait"
  
}) {
  return null
}